'use client'

import { Switch } from '@ui/components/shadcn/ui/switch'

import { BaseFieldProps, FieldShell } from './FieldShell'

export function SwitchField({
  orientation = 'horizontal',
  ...shell
}: BaseFieldProps & { orientation?: 'vertical' | 'horizontal' }) {
  return (
    <FieldShell<boolean> orientation={orientation} {...shell}>
      {({ field, controlProps }) => (
        <Switch
          {...controlProps}
          checked={field.state.value}
          onCheckedChange={field.handleChange}
          onBlur={field.handleBlur}
        />
      )}
    </FieldShell>
  )
}
